import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Vendor } from '../helpers/InterfacesServer';

interface VendorsState {
  value: Map<string, Vendor>
}

export const vendorsDict = createSlice({
  name: 'vendorsDict',
  initialState: {
    value: new Map<string, Vendor>(),
  } as VendorsState,
  reducers: {
    setVendorsDict: (state, action: PayloadAction<Map<string, Vendor>>) => {
      state.value = action.payload
    },
  },
})

export const { setVendorsDict } = vendorsDict.actions;
export default vendorsDict.reducer;